var Equation = function (operator, lhs1, lhs2, rhs, aux = null) {
  this.operator = operator
  this.lhs1 = lhs1
  this.lhs2 = lhs2
  this.rhs = rhs
  this.aux = aux
}
// functions to check equality to a given value
Equation.prototype.lhs1Equals = function (value) {
  return this.lhs1.equals(value)
}
Equation.prototype.lhs2Equals = function (value) {
  return this.lhs2.equals(value)
}
Equation.prototype.rhsEquals = function (value, aux = null) {
  if (!this.aux) return this.rhs.equals(value)
  if (this.aux && !aux) return false
  return this.rhs.equals(value) && this.aux.equals(aux)
}
// functions to convert to a string
Equation.prototype.toString = function (parentheses = false) {
  return this.lhsString(parentheses) + ' = ' + this.rhsString()
}
Equation.prototype.lhsString = function (parentheses = false) {
  return this.lhs1String(parentheses) + ' ' + this.operator + ' ' + this.lhs2String(parentheses)
}
Equation.prototype.lhs1String = function (parentheses = false) {
  if (!this.lhs1.isNegative()) return this.lhs1.toString()
  if (parentheses === false) return this.lhs1.toString()
  return '(' + this.lhs1.toString() + ')'
}
Equation.prototype.lhs2String = function (parentheses = false) {
  if (!this.lhs2.isNegative()) return this.lhs2.toString()
  if (parentheses === false) return this.lhs2.toString()
  return '(' + this.lhs2.toString() + ')'
}
Equation.prototype.rhsString = function () {
  if (!this.aux) return this.rhs.toString()
  return this.rhs.toString() + ' R ' + this.aux.toString()
}
// valid ONLY WHEN operands are Decimal objects
// functions to get the actual number of places (digits)
Equation.prototype.lhs1Places = function () {
  var lhs1wholeplaces = this.lhs1.trunc().toString().length
  var lhs1decplaces = this.lhs1.decimalPlaces()

  return lhs1wholeplaces + lhs1decplaces
}
Equation.prototype.lhs2Places = function () {
  var lhs2wholeplaces = this.lhs2.trunc().toString().length
  var lhs2decplaces = this.lhs2.decimalPlaces()

  return lhs2wholeplaces + lhs2decplaces
}
Equation.prototype.rhsPlaces = function () {
  var rhswholeplaces = this.rhs.trunc().toString().length
  var rhsdecplaces = this.rhs.decimalPlaces()

  return rhswholeplaces + rhsdecplaces
}
// functions to find the maximum possible number of places (digits)
Equation.prototype.rhsMaxPlaces = function () {
  return this.rhsMaxWholePlaces() + this.rhsMaxDecPlaces()
}
Equation.prototype.rhsMaxWholePlaces = function () {
  var lhs1wholeplaces = this.lhs1.trunc().toString().length
  var lhs2wholeplaces = this.lhs2.trunc().toString().length

  // return the maximum possible number of whole places in rhs
  if (this.operator === '+') return Math.max(lhs1wholeplaces, lhs2wholeplaces) + 1
  if (this.operator === '−') return Math.max(lhs1wholeplaces, lhs2wholeplaces)
  if (this.operator === '×') return lhs1wholeplaces + lhs2wholeplaces
  if (this.operator === '÷') return lhs1wholeplaces

  // if can't find, return the actual number of whole places in rhs
  return this.rhs.trunc().toString().length
}
Equation.prototype.rhsMaxDecPlaces = function () {
  var lhs1decplaces = this.lhs1.decimalPlaces()
  var lhs2decplaces = this.lhs2.decimalPlaces()

  // return the maximum possible number of decimal places in rhs
  if (this.operator === '+') return Math.max(lhs1decplaces, lhs2decplaces)
  if (this.operator === '−') return Math.max(lhs1decplaces, lhs2decplaces)
  if (this.operator === '×') return lhs1decplaces + lhs2decplaces
  if (this.operator === '÷') return lhs2decplaces + 3 // up to thousandths

  // if can't find, return the actual number of decimal places in rhs
  return this.rhs.decimalPlaces()
}

export default Equation



// WEBPACK FOOTER //
// ./src/math/types/equation.js